import React from 'react';
import { ShoppingCart, Plus } from 'lucide-react';

// Modal de "Pedido Mínimo" do cardápio público.
// Extraído VERBATIM de PublicMenu.js (Fase 2 refactor). Componente puro (sem hooks),
// recebe estado/handlers via props. Renderizado como <MinimumOrderModal .../>.
const MinimumOrderModal = ({
  showMinOrderModal,
  restaurant,
  getCartTotal,
  setShowMinOrderModal,
  setCurrentScreen,
}) => {
  if (!showMinOrderModal) return null;

  const minimumOrder = restaurant?.minimum_order || 0;
  const cartTotal = getCartTotal();
  const remaining = minimumOrder - cartTotal;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center px-4">
      {/* Backdrop suave */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-40"
        onClick={() => setShowMinOrderModal(false)}
      />
      
      {/* Modal Compacto */}
      <div className="relative bg-white rounded-2xl w-full max-w-sm shadow-xl animate-scale-in overflow-hidden">
        {/* Barra superior colorida */}
        <div className="h-1.5 bg-gradient-to-r from-amber-400 to-orange-400"></div>
        
        {/* Conteúdo */}
        <div className="p-5">
          {/* Header inline */}
          <div className="flex items-center space-x-3 mb-4">
            <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center">
              <ShoppingCart className="w-5 h-5 text-amber-600" />
            </div>
            <div>
              <h3 className="font-bold text-gray-800">Quase lá!</h3>
              <p className="text-xs text-gray-500">Pedido mínimo para delivery</p>
            </div>
          </div>
          
          {/* Valores em linha */}
          <div className="bg-gray-50 rounded-xl p-3 mb-4">
            <div className="flex justify-between text-sm mb-2">
              <span className="text-gray-500">Seu carrinho</span>
              <span className="font-semibold">R$ {cartTotal.toFixed(2)}</span>
            </div>
            <div className="flex justify-between text-sm mb-2">
              <span className="text-gray-500">Mínimo</span>
              <span className="font-semibold text-amber-600">R$ {minimumOrder.toFixed(2)}</span>
            </div>
            <div className="border-t border-gray-200 pt-2 flex justify-between">
              <span className="text-gray-700 font-medium text-sm">Falta</span>
              <span className="font-bold text-orange-500">R$ {remaining.toFixed(2)}</span>
            </div>
          </div>
          
          {/* Botões lado a lado */}
          <div className="flex space-x-3">
            <button
              onClick={() => setShowMinOrderModal(false)}
              className="flex-1 py-2.5 px-4 border border-gray-200 rounded-xl text-gray-600 text-sm font-medium hover:bg-gray-50 transition-colors"
            >
              Voltar
            </button>
            <button
              onClick={() => {
                setShowMinOrderModal(false);
                setCurrentScreen('home');
              }}
              className="flex-1 py-2.5 px-4 bg-primary text-white rounded-xl text-sm font-medium hover:bg-primary-hover transition-colors flex items-center justify-center space-x-1"
            >
              <Plus className="w-4 h-4" />
              <span>Adicionar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MinimumOrderModal;
